import { render, staticRenderFns } from "./SvgComponent.vue?vue&type=template&id=788e9297"
import script from "./SvgComponent.vue?vue&type=script&lang=js"
export * from "./SvgComponent.vue?vue&type=script&lang=js"
import style0 from "./SvgComponent.vue?vue&type=style&index=0&id=788e9297&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports